
import React from 'react';
import { Language } from '../types';
import { TRANSLATIONS } from '../translations';
import { Star, Gift, ArrowRight, History } from 'lucide-react';

interface PointsCardProps {
  points: number;
  language: Language;
  onClaim?: () => void;
}

export const PointsCard: React.FC<PointsCardProps> = ({ points, language, onClaim }) => {
  const t = TRANSLATIONS[language];

  return (
    <div className="bg-gradient-to-br from-indigo-900 to-slate-900 border border-indigo-500/30 rounded-xl p-5 relative overflow-hidden group">
      <div className="absolute top-0 right-0 w-32 h-32 bg-indigo-500/20 rounded-bl-full -mr-8 -mt-8 transition-transform group-hover:scale-110"></div>
      
      <div className="relative z-10 flex flex-col h-full justify-between">
        <div>
            <div className="flex items-center gap-2 mb-2">
                <div className="p-1.5 bg-indigo-500/20 rounded-lg">
                    <Star size={18} className="text-yellow-400" fill="currentColor" />
                </div>
                <span className="text-indigo-200 font-medium text-sm">{t.linkKolPoints}</span>
            </div>
            <h3 className="text-3xl font-bold text-white mb-1">{points.toLocaleString()}</h3>
            <p className="text-xs text-indigo-300">{t.pointsBalance}</p>
        </div>

        <div className="mt-6 pt-4 border-t border-indigo-500/30 flex items-center justify-between">
            <button 
                onClick={onClaim}
                className="text-xs text-white bg-indigo-600 hover:bg-indigo-700 px-3 py-1.5 rounded-lg flex items-center gap-1 transition-colors"
            >
                <Gift size={12} /> {t.viewRewards}
            </button>
            <div className="flex items-center gap-1 text-[10px] text-indigo-400">
                <span>{t.convertToToken}</span>
                <span className="bg-indigo-950 px-1.5 py-0.5 rounded text-indigo-300">{t.comingSoon}</span>
            </div>
        </div>
      </div>
    </div>
  );
};
